import { Component, HostBinding, Injector, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { SettingsCountingHistogramBaseComponent } from '@rift/components/settings/counting/shared/settings/base/SettingsCountingHistogramBase.Component';
import { UnitsOfMeasurementInputValidators } from '@rift/directives/unitsofmeasurementinput/UnitsOfMeasurementInput.Directive';
import { HistogramConfigModel } from '@rift/models/restapi/HistogramConfig.Model';
import { ProcessMonitorServiceProcess } from '@shared/service/processmonitor/ProcessMonitor.Service.Process';

@Component({
    selector: 'rift-settings-counting-height-histogram',
    templateUrl: './Settings.Counting.HeightHistogram.Component.html',
    styleUrls: ['./Settings.Counting.HeightHistogram.Component.scss']
})
export class SettingsCountingHeightHistogramComponent extends SettingsCountingHistogramBaseComponent implements OnChanges {
    public static binWidthDefault: number = 0;
    public static className: string = 'SettingsCountingHeightHistogramComponent';
    public static minimumValueDefault: number = 0;
    public static numberOfBinsDefault: number = 0;

    @HostBinding()
    public id: string = 'rift-settings-counting-height-histogram';

    public formValuesChangeProcess: ProcessMonitorServiceProcess;

    public constructor(
        private readonly _formBuilder: FormBuilder,
        private readonly _injector: Injector) {
        super(_injector);

        this.formValuesChangeProcess = this.processMonitorService.getProcess(SettingsCountingHeightHistogramComponent.className, 'Form values change');

        this.form = this._formBuilder.group(
            {
                minimumValue: ['', Validators.compose([Validators.required, UnitsOfMeasurementInputValidators.min()])],
                binWidth: ['', Validators.compose([Validators.required, UnitsOfMeasurementInputValidators.min()])],
                numberOfBins: ['', Validators.compose([Validators.required, Validators.min(1)])],
            }
        );

        this.addSubscription(this.observableHandlerBase(this.form.valueChanges, this.formValuesChangeProcess).subscribe(() => {
            if (!this.isNullOrUndefined(this._histogramConfig)) {
                this._histogramConfig.minimumValue = parseFloat(this.form.controls.minimumValue.value);
                this._histogramConfig.binWidth = parseFloat(this.form.controls.binWidth.value);
                this._histogramConfig.numberOfBins = parseFloat(this.form.controls.numberOfBins.value);
            }
        }), this.formValuesChangeProcess);

        this.formGroupTracker.track(this.form);
        this.setFormState();

        this.initConnectionState();
    }

    public getSettingsDescription(): string {
        return this.enabled === true ? 'Enabled' : 'Disabled';
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (!this.isNullOrUndefined(changes.register) && !this.isNullOrUndefined(changes.register.currentValue)) {
            this.enabled = this._hadHistogramConfig = this.register.hasHeightHistogram;
            if (this.enabled) {
                this._histogramConfig = this.register.heightHistograms[0];
            } else {
                this._histogramConfig = new HistogramConfigModel();
                this._histogramConfig.binWidth = SettingsCountingHeightHistogramComponent.binWidthDefault;
                this._histogramConfig.numberOfBins = SettingsCountingHeightHistogramComponent.numberOfBinsDefault;
                this._histogramConfig.minimumValue = SettingsCountingHeightHistogramComponent.minimumValueDefault;
                this._histogramConfig.expression = `h;`;
                this._histogramConfig.commitChanges();
            }

            this.setFormState();
            this.setFormValues(
                SettingsCountingHeightHistogramComponent.binWidthDefault,
                SettingsCountingHeightHistogramComponent.numberOfBinsDefault,
                SettingsCountingHeightHistogramComponent.minimumValueDefault
            );
        }
    }

    public get hasChanges(): boolean {
        return this.isNullOrUndefined(this._histogramConfig) ? false :
            this._histogramConfig.propertyHasChanges('binWidth') ||
            this._histogramConfig.propertyHasChanges('numberOfBins') ||
            this._histogramConfig.propertyHasChanges('minimumValue') ||
            this._histogramConfig.propertyHasChanges('expression');
    }

    public get isValid(): boolean {
        return this.isValidBase;
    }

    protected offline(): void {
        super.offline();
        this.form.disable();
    }

    protected online(): void {
        super.online();
        this.form.enable();
    }
}
